import { render } from "./SchoolActivationConfirm.vue?vue&type=template&id=6f14182f&ts=true"
import script from "./SchoolActivationConfirm.vue?vue&type=script&lang=ts"
export * from "./SchoolActivationConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__